// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWorkItemTypesRequestModel from '../../model/get-work-item-types-request-model';
import GetWorkItemTypesRequestDTO from '../dto/get-work-item-types-request-dto';
import dtoSchema from '../schemas/get-work-item-types-request-schema';

export default abstract class GetWorkItemTypesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWorkItemTypesRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<GetWorkItemTypesRequestDTO>): GetWorkItemTypesRequestModel;
  static toModel(dto: DeepPartial<GetWorkItemTypesRequestDTO> | undefined | null): GetWorkItemTypesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWorkItemTypesRequestDTO> | undefined | null): GetWorkItemTypesRequestModel | undefined {
    return dto ? new GetWorkItemTypesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWorkItemTypesRequestModel> | GetWorkItemTypesRequestModel): GetWorkItemTypesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
    } as GetWorkItemTypesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWorkItemTypesRequestModel, can not map to GetWorkItemTypesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
